import { recipeName } from '../i18n/format';
import { useMessages } from '../i18n/LanguageProvider';
import { FoodIcon, FoodPlate } from '../pictures/FoodPlate';
import { recipePicture } from '../pictures/pictures';
import { recipeById } from '../recipes/recipe-lookup';
import type { TodaySummary } from './today-summary';

/**
 * DE: Blick auf morgen: Gericht, Fisch und Gesamtzeit.
 * EN: A look at tomorrow: dinner, fish and total time.
 */
export function TomorrowCard({ tomorrow }: { tomorrow: NonNullable<TodaySummary['tomorrow']> }) {
  const { language, t } = useMessages();
  return (
    <section className="app-card app-tomorrow">
      <FoodPlate picture={recipePicture(tomorrow.recipeId)} size={52} />
      <div className="app-tomorrow-text">
        <h2>{t.tomorrowTitle}</h2>
        <p className="app-tomorrow-name">{recipeName(recipeById(tomorrow.recipeId), language)}</p>
      </div>
      <div className="app-tomorrow-side">
        {tomorrow.fish && (
          <span className="app-chip app-chip-fish">
            <FoodIcon picture="fish" size={16} />
            {t.fish}
          </span>
        )}
        <span className="app-tomorrow-time">{t.minutes(tomorrow.totalMinutes)}</span>
      </div>
    </section>
  );
}
